import React from 'react'
import { WithErrorBoundary } from '../common/ErrorBoundary'

const PseudoPresupuestador = WithErrorBoundary(
  'Gestion operativa - Modificacion',
  'Error en Gestion Operativa',
  React.lazy(() => import('./PseudoPresupuestador')),
)
const MainGestionOperativa = WithErrorBoundary(
  'Gestion operativa',
  'Error en Gestion Operativa',
  React.lazy(() => import('./MainGestionOperativa')),
)

export default {
  path: '/solicitud-venta',
  name: 'Solicitud Venta',
  childRoutes: [
    { path: 'crear/:budget_id', name: 'crear', component: MainGestionOperativa },
    { path: 'editar/:sales_id', name: 'editar', component: MainGestionOperativa },
    { path: 'ver/:sales_id', name: 'ver', component: MainGestionOperativa },
    { path: 'card-interface', name: 'Pseudo presupuestador', component: PseudoPresupuestador },
  ],
}
